var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-reported-issues"},[_c('div',{staticClass:"v-reported-issues__container"},[_c('h2',[_vm._v(_vm._s(_vm.$t('view.reportedIssues.title')))]),_c('c-games-filter')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }